import ModalTabuYashirRequestPending from './ModalTabuYashirRequestPending';

export default ModalTabuYashirRequestPending;
